import React from "react";
import styled from "styled-components";

const FormInput = styled.input`
  padding: 16px 28px;
  border: none;
  background: #2f2323;
  backdrop-filter: blur(10px);
  border-radius: 50px;
  position: static;
  color: #fffcf2;
  width: 100%;
  font-family: Poppins;
  &:focus {
    outline: none;
  }
`;

const InputLabel = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #fffcf2;
  margin-left: 20px;
`;

const AreaInput = styled.textarea`
  padding: 16px 28px;
  border: none;
  background: #2f2323;
  backdrop-filter: blur(10px);
  border-radius: 50px;
  position: static;
  color: #fffcf2;
  width: 100%;
  height: auto;
  font-family: Poppins;
  &:focus {
    outline: none;
  }
`;

export { FormInput, InputLabel, AreaInput };
